// todo: add toc
export default function Services() {
	const results = categoryInfo.map(category => {
		const matchingServices = services.filter(
			service => category.name === service.category,
		)
		return (
			<div key={category.name} className="mb-10">
				<h2 className="mb-3 text-3xl">{category.name}</h2>
				<p className="mb-2">{category.description}</p>
				<h3 className="text-2xl">Services</h3>
				<div>
					{matchingServices.map(service => {
						return (
							<div key={service.name} className="mb-3">
								<h4 className="text-lg">{service.name}</h4>
								<p>{service.contents}</p>
								{service.tools && (
									<div>
										{service?.tools.map(tool => {
											return <div key={tool}>{tool}</div>
										})}
									</div>
								)}
							</div>
						)
					})}
				</div>
				<h3 className="mb-2 text-xl">Qualifications</h3>
				<ul className="mb-2 ml-5 list-disc">
					{category.qualifications.map(qualification => {
						return <li key={qualification}>{qualification}</li>
					})}
				</ul>
			</div>
		)
	})
	return (
		<div className="container mx-auto py-2">
			<h1 className="mb-3 text-5xl">Services</h1>
			{results}
		</div>
	)
}

const categoryInfo = [
	{
		name: 'Data Engineering',
		// todo: add icon
		description: 'Architecting and building data pipelines',
		qualifications: [
			"I've previously worked at Databricks for 4 years as a Senior Staff Customer Success Engineer",
			'I am currently an Authorized Training Partner, training their clients in Data Engineering and Data Analytics',
		],
	},
	{
		name: 'Full Stack Engineering',
		// todo: add icon
		description: 'Creating web applications from front-end to back-end',
		qualifications: ['Built web applications at Databricks and AppDynamics'],
		tools: [
			'ReactJS',
			'Typescript',
			'NextJS',
			'git',
			'VSCode',
			'Postgresql',
			'Tailwind',
		],
	},
	{
		name: 'Customer Success for Enterprise IT',
		// todo: add icon
		description: 'Helping customers adopt enterprise software',
		qualifications: [
			'Previously Senior Staff Customer Success Engineer at Databricks',
			'Built dashboards with key metrics to measure feature adoption',
			'Helped with organizational design for CS roles and interface to product',
		],
	},
	{
		name: 'APM (Application Performance Management)',
		// todo: add icon
		description: 'Architecting and building data pipelines',
		qualifications: [
			'Worked at AppDynamics as a Customer Success Engineer',
			'Worked at AppDynamics as a Senior Consultant in Professional Services',
		],
	},
]

const services = [
	{
		category: 'Data Engineering',
		name: 'Architecture Review',
		contents: `Review your existing data architecture and present a comprehensive assessment report. The report will include an evaluation of your current architecture's performance, scalability, security, resilience, and compliance with industry standards and best practices. It will identify potential gaps and areas of improvement.`,
	},
	{
		category: 'Data Engineering',
		name: 'Databricks Training',
		contents:
			'Training sessions on the optimized data architecture and new tools if applicable. Detailed documentation, including system design, operational instructions, and troubleshooting guidelines, will be provided.',
		deliverables: [
			'Apache Spark',
			'Databricks Data Engineering',
			'Databricks Data Analytics',
			'Databricks Platform Administration',
		],
	},
	{
		category: 'Data Engineering',
		name: 'Training',
		contents:
			'Training sessions on the optimized data architecture and new tools if applicable. Detailed documentation, including system design, operational instructions, and troubleshooting guidelines, will be provided.',
	},
	{
		category: 'Fullstack Engineering',
		name: 'Architecture Review',
		contents: 'Improve your existing architecture.',
		deliverables: [
			'Architecture design',
			'Testing practices',
			'Performance optimization',
			'DevOps integration: CI/CD',
		],
		tools: ['ReactJS'],
	},
	{
		category: 'Fullstack Engineering',
		name: 'Engineering Management',
		contents: 'stuff',
		deliverables: ['Architecture '],
		tools: ['ReactJS'],
	},
	{
		category: 'APM (Application Performance Management)',
		name: 'Architecture Review',
		contents:
			'Comprehensive review, optimization, and implementation of Application Performance Management systems. Our team of seasoned experts works diligently to ensure that your applications are high-performing, resilient, and efficient. Through a rigorous examination of your existing APM architecture and practices, we can identify potential bottlenecks and inefficiencies, then suggest and implement best-in-class solutions.',
		deliverables: ['Service Mapping', 'Key Metrics', 'Alerts', 'Dashboards'],
	},
	{
		category: 'Customer Success',
		name: 'Onboarding Process Optimization',
		contents: `Streamline your customer interactions with your product or service, ensuring they derive maximum value from their investment.

			Designed to work closely with your product, engineering, and customer success teams, this service enhances the user experience, reduces churn, and promotes customer loyalty and satisfaction by proactively addressing technical challenges and enhancing the user experience.`,
		deliverables: [
			'Customer Onboarding Milestones',
			'Key Metrics and Success Criteria',
			'Onboarding Assets',
		],
	},
]
